<div id="about">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                <h2>ABOUT US</h2>
                <hr class=" p-1 mx-auto opacity-100" style="width: 160px;">
            </div>
        </div>
        <div class="d-flex row">
            <div class="col-lg-5 col-md-5 col-sm-5">
                <img appLazyload src="/assets/img/showcase/2.png" alt="Maharana Pratap Public School" class="img-fluid">
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7">
                <h3>Welcome To Maharana Pratap Public School</h3>
                <hr >
                <p class="lead">Maharana Pratap Public School, started in the year 1992, is an institution of the Kshatriya Sabha, Kurukshetra (Regd.) Haryana.
                    It is a co-educational English medium school, affiliated to the CBSE, New Delhi.
                     It is managed by the Maharana Pratap Shiksha Samiti comprising highly qualified and reputed persons with vast experience in the field of education.
                    The school is run by qualified, devoted and experienced staff who help the students to not only achieve academic excellence but also help them develop their innate talents and abilities.</p>
                <div class="d-flex row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div id="accordion">
                            <div class="card mb-1">
                                <div class="card-header ">
                                    <h5 href="#collapse1" 
                                        data-toggle="collapse">Our History: The epitome of valour and honour<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse1" data-parent="#accordion">
                                        
                                        <div class="card-body">
                                            Maharana Pratap, the ruler of Mewar, was the grandson of Rana Sangram Singh, popularly known as Sanga, and son of Rana Udal Singh.
                                             Sanga was a highly distinguished leader of the Rajputs, but Pratap should be considered greater for standing up to the might of the Mughal Emperor, Akbar, and keeping the honour of his people unsullied.
                                              When almost every other ruler of Rajputana accepted servility under Akbar, Maharana Pratap refused to succumb.
                                               He actually won the respect of his great opponent by scorning all attempts at alliances and foresaking palace comforts and even his kingdom to preserve honour. His exploits in the battle of Haldighati make him a warrior par excellence, an astute general and a generous foe. He practised hospitality to a fault.
                                             Pursued and persecuted by the Mughals, whosoever sought his protection, found in Mewar a welcome haven.
                                            
                                        </div>
                                    </div>
                            
                            </div>

                            <!-- <div class="card mb-1">
                                <div class="card-header">
                                    <h5 href="#collapse2" 
                                        data-toggle="collapse">Why MPPS?<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse2" data-parent="#accordion">
                                    
                                        <div class="card-body">
                                            Maharana Pratap Public School, started in the year 1992, is an institution of the Kshatriya Sabha, Kurukshetra (Regd.) Haryana.
                                             It is a co-educational English medium school, affiliated to the CBSE, New Delhi. It is managed by the Maharana Pratap Shiksha Samiti comprising highly qualified and reputed persons with vast experience in the field of education.
                                             The school is run by qualified, devoted and experienced staff who help the students to not only achieve academic excellence but also help them develop their innate talents and abilities.
                                            <br>
                                        </div>
                                    </div>
                                
                            </div> -->

                            <div class="card mb-1">
                                <div class="card-header">
                                    <h5 href="#collapse3" 
                                        data-toggle="collapse">Our Vision & Mission<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse3" data-parent="#accordion">
                                    
                                        <div class="card-body">
                                            <h5>Vision</h5>
                                            To be a temple of learning where the devotees are nurtured to worship knowledge and harness it for the good of mankind.
                                            <br>
                                            <br>
                                            <h5>Mission</h5>
                                            <ul>
                                                <li>To provide quality education to the children with minimum financial burden on the parents. </li>
                                                <li>To ensure  physical mental and moral growth of the students and create in them a zest for learning.</li>
                                                <li>To judiciously arouse their aesthetic sense and inculcate habits of personal as well as social hygiene for overall well being.</li>
                                                <li>To engage the students in cooperative endeavors so as to develop in them team spirit and a service mentality.</li>
                                                <li>To channelize youthful energies towards creativity & self actualization.</li>
                                               
                                            </ul>
                                        </div>
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       
       
    </div>
    
</div>


<app-member></app-member>
<!-- <app-points></app-points> -->

<!-- <section class="about pt-md-4" data-scroll>
    <div class="container-fluid">
    <div class="row">
    <div class="col-md-12 col-xs-12 col-lg-4 pl-md-0 left-side">
    <div class="heading-section">
    <div class="heading pb-md-5 pl-md-4 ml-md-5">
    <h2 class="h3  pb-1 ">About SPS</h2>
    </div>
    </div>
    <div class="image mt-1 d-none d-lg-block">
    <img appLazyload [src]="imgUrl" alt="Building" class="img-fluid rounded">
    </div>
    </div>
    <div class="col-md-12 col-xs-12 col-lg-8 py-5 bg-light right-side">
    <div class="content border-bottom pb-3 mb-1 aboutus-content">
    <div class="font-size-16 secondary-1 mb-0 pr-md-5 paragraph wiswig">
        <p class="lead text-justify">Maharana Pratap Public School, started in the year 1992, is an institution of the Kshatriya Sabha, Kurukshetra (Regd.) Haryana. It is a co-educational English medium school, affiliated to the CBSE, New Delhi.
        </p>
        <p class="lead text-justify">It is managed by the Maharana Pratap Shiksha Samiti comprising highly qualified and reputed persons with vast experience in the field of education.
             The school is run by qualified, devoted and experienced staff who help the students to not only achieve academic excellence but also help them develop their innate talents and abilities.</p>
       
    </div>
    <a  routerLink="/about/profile" class="btn btn-outline-warning py-2 pl-3">Read more <i class="bi bi-arrow-right"></i></a>
    </div>
    <div class="row mt-4">
    <div class="col-md-6 col-lg-6">
    <div class="content">
    <div class="header d-flex align-items-center pb-3 ">
        <i class="fas fa-shield-alt"></i>
    <p class="secondary-1 font-size-14 m-0 pl-3">Security</p>
    </div>
    </div>
    </div>
    <div class="col-md-6 col-lg-6">
    <div class="content">
    <div class="header d-flex align-items-center pb-3 ">
        <i class="fas fa-flask"></i>
    <p class="secondary-1 font-size-14 m-0 pl-3">Labs</p>
    </div>
    </div>
    </div>
    
    <div class="col-md-6 col-lg-6">
        <div class="content">
        <div class="header d-flex align-items-center pb-3 ">
            <i class="fas fa-marker"></i>
        <p class="secondary-1 font-size-14 m-0 pl-3">Skill Boosters</p>
        </div>
        </div>
        </div>
        <div class="col-md-6 col-lg-6">
        <div class="content">
        <div class="header d-flex align-items-center pb-3 ">
            <i class="fas fa-desktop"></i>
        <p class="secondary-1 font-size-14 m-0 pl-3">Computer Lab</p>
        </div>
        </div>
        </div>
        <div class="col-md-6 col-lg-6">
        <div class="content">
        <div class="header d-flex align-items-center pb-3 ">
            <i class="fas fa-book"></i>
        <p class="secondary-1 font-size-14 m-0 pl-3">Library</p>
        </div>
        </div>
        </div>
        <div class="col-md-6 col-lg-6">
            <div class="content">
            <div class="header d-flex align-items-center pb-3 ">
                <i class="fas fa-university"></i>
            <p class="secondary-1 font-size-14 m-0 pl-3">Campus</p>
            </div>
            </div>
            </div>
    </div>
   
   
    </div>
    </div>
    </div>
    </section>

 -->
